import React from 'react'
import { Link } from 'gatsby'
// import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import Container from './container'

const Footer = () => (
  <Container as="footer">
    <div className="contain">
      <div className="footerNavigation">
          <div className="signup" id="signup">
            <div id="mc_embed_signup">
              <Link to="/"><h6>Drivey</h6></Link>
              <p>Join our newsletter and stay tuned with the newest news.</p>
              <form action="https://drivey.us20.list-manage.com/subscribe/post?u=5c9f63740e34f5304a9e94302&amp;id=810ecac1e4" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                <div id="mc_embed_signup_scroll">
                  <input type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="Enter your email" required />
                  <div className="hideMe" aria-hidden="true"><input type="text" name="b_5c9f63740e34f5304a9e94302_810ecac1e4" tabIndex="-1" value="" /></div>
                  <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe"  />
                </div>
              </form>
            </div>
            <div className="links">
              <div className="link linkOne">
                <Link to="/">Home</Link>
                <Link to="/features">Features</Link>
                <Link to="/connectors">Connectors</Link>
                {/* <Link to="/pricing">Pricing</Link> */}
                <Link to="/blog">Blog</Link>
              </div>
              <div className="link">
                {/* <Link to="/tutorials">Tutorials</Link> */}
                {/* <Link to="/migrations">Migrations</Link> */}
                {/* <Link to="/storage">Storage</Link> */}
              </div>
              <div className="social">
                <Link to="https://www.facebook.com/DriveyCloud/" target="_blank"><FaFacebookF/> Facebook</Link>
                <Link to="https://www.linkedin.com/showcase/drivey/" target="_blank"><FaLinkedinIn/> LinkedIn</Link>
                <Link to="https://twitter.com/DriveyCloud" target="_blank"><FaTwitter/> Twitter</Link>
              </div>
            </div>
          </div>
      </div>
      <div className="copyright">
          <p>&copy; Copyright {new Date().getFullYear()} Drivey - All rights reserved.</p>
          <ul>
              <li><Link to="/terms">Terms and conditions</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
          </ul>
      </div>
    </div>
  </Container>
)

export default Footer
